import service from "@/utils/request";
export interface homeworkData {
  page: number;
  page_size: number;
  title?: string;
  staff_ids?: number;
  class_id?: number;
  start_time?: number;
  end_time?: number;
  student_id?: number;
  type?: number;
  sort_field?: string;
  sort_type?: string;
}
//练习列表
export const homeworkList = (params: homeworkData) => {
  return service({
    url: "/api/v1/homework/list",
    method: "get",
    params,
  });
};
//练习删除
export const homeworkDel = (data: { homework_ids: any }) => {
  return service({
    url: "/api/v1/homework/del",
    method: "post",
    data,
  });
};
//练习增加
export interface homeworkAddData {
  title?: string;
  type?: number;
  publish_type?: number;
  publish_time?: number;
  class_students?: [];
  content_list?: [];
}
export const homeworkAdd = (data: homeworkAddData) => {
  return service({
    url: "/api/v1/homework/add",
    method: "post",
    data,
  });
};
//班级列表
export const classList = (params: {
  page: number;
  page_size: number;
  class_name: string;
}) => {
  return service({
    url: "/api/v1/homework/class_list",
    method: "get",
    params,
  });
};
//班级学员列表
export const classStudentList = (params: { class_id: number }) => {
  return service({
    url: "/api/v1/homework/class_student_list",
    method: "get",
    params,
  });
};
//课次列表
export const lessonList = (params: {
  page: number;
  page_size: number;
  class_id?: number;
  start_time?: number;
  end_time?: number;
}) => {
  return service({
    url: "/api/v1/homework/lesson_list",
    method: "get",
    params,
  });
};
//课次学员列表
export const lessonStudentList = (params: {
  class_id: number;
  lesson_id: number;
}) => {
  return service({
    url: "/api/v1/homework/lesson_student_list",
    method: "get",
    params,
  });
};
//练习详情
export const homeworkDetail = (params: { homework_id: number }) => {
  return service({
    url: "/api/v1/homework/detail",
    method: "get",
    params,
  });
};
//已批改
export const correctedList = (params: { homework_id: number }) => {
  return service({
    url: "/api/v1/homework/corrected_list",
    method: "get",
    params,
  });
};
//待批改
export const beCorrectList = (params: { homework_id: number }) => {
  return service({
    url: "/api/v1/homework/be_correct_list",
    method: "get",
    params,
  });
};
//未提交
export const notSubmitList = (params: { homework_id: number }) => {
  return service({
    url: "/api/v1/homework/not_submit_list",
    method: "get",
    params,
  });
};
export interface correctInter {
  student_answer_id: number;
  content: string;
  star_num: number;
  redo?: number;
}
//教师批改
export const correct = (data: correctInter) => {
  return service({
    url: "/api/v1/homework/correct",
    method: "post",
    data,
  });
};
//教材目录列表
export const getDirectoryListApi = (params: {
  book_id: number;
  key_word?: string;
}) => {
  return service({
    url: "/api/v1/book/directory_list",
    method: "get",
    params,
  });
};
//教材目录下的练习列表
export const getHomeworkListApi = (params: { directory_id: number }) => {
  return service({
    url: "/api/v1/homework/book_directory_list",
    method: "get",
    params,
  });
};
export interface homeworkDetailListInter {
  page: number;
  page_size: number;
  homework_id?: number;
  title?: string;
  student_id?: number;
  start_time?: number;
  end_time?: number;
  status?: number[];
  corrected_staff_id?: number;
  sort_field?: string;
  sort_type?: string;
  include_unpublished?: boolean;
}
// 练习明细列表
export const getHomeworkDetailListApi = (data: homeworkDetailListInter) => {
  return service({
    url: "/api/v1/homework/detail_list",
    method: "post",
    data,
  });
};
// 学员答案详情(客户端)
export const getHomeworkStudentAnswerDetailApi = (params: {
  homework_student_id: number;
  homework_id: number;
}) => {
  return service({
    url: "/api/v1/homework/student_answer_detail",
    method: "get",
    params,
  });
};
// 练习重做
export const getHomeworkRedoApi = (data: { homework_student_id: number }) => {
  return service({
    url: "/api/v1/homework/redo",
    method: "post",
    data,
  });
};
// 练习视频推荐
export const homeworkVideoRecommendApi = (data: {
  title: string;
  video: string;
  student_id: number;
  homework_id: number;
}) => {
  return service({
    url: "/api/v1/homework/recommend",
    method: "post",
    data,
  });
};
